// errorHelper.ts
export function formatAuthError(error: any): string {
    if (!error || !error.code) {
      return "There was a problem signing you up, please check your inputs and try again.";
    }
  
    switch (error.code) {
      case "auth/email-already-in-use":
        return "This email is already registered. Please sign in or use another email.";
  
      case "auth/invalid-email":
        return "The email address format looks incorrect. Please double-check it.";
  
      case "auth/weak-password":
        return "Your password is too weak. Please choose a stronger one.";
  
      case "auth/missing-password":
        return "Please enter a password.";
  
      case "auth/operation-not-allowed":
        return "This sign-up method is currently disabled. Please contact support.";
  
      default:
        return "There was a problem signing you up, please check your inputs and try again.";
    }
  }
  